import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Card, CardContent, Grid, Step, StepLabel, Stepper, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

const orderTimeline = [
    {
        title: "Order Placed",
        date: "12/7/2025, 4:47:53 PM",
        completed: true,
        icon: <RadioButtonUncheckedIcon />,
    },
    {
        title: "Order Confirmed",
        date: "12/7/2025, 4:47:53 PM",
        completed: true,
        icon: <CheckCircleIcon />,
    },
    {
        title: "Order Shipped",
        date: "12/9/2025, 4:47:53 PM",
        tracking: "TRK-10001",
        completed: true,
        icon: <LocalShippingIcon />,
    },
    {
        title: "Order Delivered",
        date: "12/11/2025, 4:47:53 PM",
        completed: true,
        icon: <CheckCircleIcon />,
    },
];


const ViewPayoutSP: React.FC = () => {
    const navigate = useNavigate();

    // Static order data


    const payout = {
        vendorId: "SP-1001",
        vendorName: "TechHub Electronics",
        subscriptionType: "Premium",
        commission: "10%",
        payoutType: "7 Days",
        pendingAmount: "AED 4,250.00",
        lastPayoutDate: "15 Mar 2025",
        lastPayoutAmount: "AED 12,800.00",
        platformFees: "AED 1,250.00",
        shippingRate: "AED 15 / order",
    };



    return (
        <>
            <div className="view_order_page">
                <div className="main_title">
                    <h1>View Payout</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                        <button onClick={() => navigate("/sp-payouts")}>
                            Service Provider Payout
                        </button>{" "}
                        - View Payout
                    </p>
                </div>

                {/* Order Summary */}
                {/* Vendor Payout Summary */}
                <div className="cards view_page">
                    <h3>Payout Summary</h3>

                    <div className="gap_p">
                        <div className="w_33">
                            <h6>Service Provider ID</h6>
                            <p>{payout.vendorId}</p>
                        </div>

                        <div className="w_33">
                            <h6>Service Provider Name</h6>
                            <p>{payout.vendorName}</p>
                        </div>

                        <div className="w_33">
                            <h6>Subscription Type</h6>
                            <p>{payout.subscriptionType}</p>
                        </div>

                        <div className="w_33">
                            <h6>Commission</h6>
                            <p>{payout.commission}</p>
                        </div>

                        <div className="w_33">
                            <h6>Payout Type</h6>
                            <p>{payout.payoutType}</p>
                        </div>
                        <div className="w_33">
                            <h6>Platform Fees</h6>
                            <p>{payout.platformFees}</p>
                        </div>

                        <div className="w_33">
                            <h6>Shipping Rate</h6>
                            <p>{payout.shippingRate}</p>
                        </div>
                        <div className="w_33">
                            <h6>Pending Amount</h6>
                            <p className="text_warning">{payout.pendingAmount}</p>
                        </div>

                        <div className="w_33">
                            <h6>Last Payout Date</h6>
                            <p>{payout.lastPayoutDate}</p>
                        </div>

                        <div className="w_33">
                            <h6>Last Payout Amount</h6>
                            <p>{payout.lastPayoutAmount}</p>
                        </div>
                        <div className="w_33">
                            <h6>Next Payment Scheduled On</h6>
                            <p>{payout.lastPayoutDate}</p>
                        </div>


                    </div>
                </div>







            </div>

        </>
    );
};

export default ViewPayoutSP;
